define('reducer-user',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    var initial = {
        ID: '',
        firstName: '',
        lastName: '',
        fullName: '',
        nickname: '',
        email: '',
        roles: [],
        commentsAccess: false
    };

    exports.default = function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
        var action = arguments[1];

        switch (action.type) {
            case 'SET_USER':
                {
                    var user = action.user || {};

                    return Object.assign({}, state, {
                        ID: user.id || initial.ID,
                        firstName: user.firstName || initial.firstName,
                        lastName: user.lastName || initial.lastName,
                        fullName: action.fullName || initial.fullName,
                        nickname: user.nickname || initial.nickname,
                        email: user.email || initial.email,
                        roles: action.roles || initial.roles,
                        commentsAccess: user.hasCommentingRoundAccess || initial.commentsAccess
                    });
                }
            default:
                return state;
        }
    };
});
